<template>
    <div class="other_wrap">
        <el-page-header @back="$core.goBack" ></el-page-header>
        <img src="../../assets/img/other.png" alt="">
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.other_wrap{
    height: 100vh;
    text-align: center;
    img{
        width: 80%;
    }
}
</style>